<template>
  <div>
    <div v-for="doc in model" :key="doc.documentTypeId">
      <SectionTitle
        icon="fas fa-file"
        :content="doc.documentTypeName"
        container-class="mt-4 mb-2"
        reverse
      />
      <div class="p-4 bg-secondary-3 border-radius--light">
        <CustomFileInput
          v-model="doc.file"
          :id="`at-service-document-${doc.documentTypeId}`"
          :ref="doc.documentTypeId"
          :key="componentKeys[doc.documentTypeId] || 0"
          display-style="normal"
          :disabled="isDisabled"
          :can-delete="!isDisabled"
          :accept="'.pdf'"
          :max-size="20"
          :attachment-id="doc.documentId"
          :name="doc.documentName"
          has-custom-download
          @download="downloadDocument(doc)"
          @delete="deleteDocument(doc)"
          custom-error-msg="El documento es requerido."
        />
      </div>
    </div>
  </div>
</template>

<script>
import alert from "@/mixin/alert.mixin";
import SectionTitle from "SectionTitle";
import atService from '@/services/pei/at';
import DocumentsService from '@/services/documents';
import CustomFileInput from "@/components/common/CustomFileInput";

export default {
  name: "AtServiceDocumentsManager",
  components: {
    SectionTitle,
    CustomFileInput,
  },
  mixins: [alert],
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      model: [],
      componentKeys: {}
    };
  },
  computed: {
  },
  methods: {
    downloadDocument(document) {
      if(!document?.documentContent) return;

      const payload = {
        contentType: null,
        filename: document.documentName,
        content: document.documentContent,
      };
      DocumentsService.Download(payload);
    },
    async deleteDocument(doc) {
      if (!!doc.documentId) {
        await atService.deleteDocument(doc.atServciceId, doc.documentTypeId);
  
        this.ShowToast(
          'Proceso Exitoso.',
          'El documento ha sido eliminado exitosamente.',
          'success'
        );
  
        this.$emit("refresh");
      }

      this.$set(this.componentKeys, doc.documentTypeId, (this.componentKeys[doc.documentTypeId] || 0) + 1);
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.model.length === 0) {
          // Primera vez: inicializar y agregar file: null
          this.model = newVal.map(doc => ({
            ...doc,
            file: null
          }));
          return;
        }

        // Solo actualiza campos que pueden cambiar desde backend
        this.model.forEach(modelDoc => {
          const incoming = newVal.find(d => d.documentTypeId === modelDoc.documentTypeId);
          if (incoming) {
            modelDoc.documentId = incoming.documentId;
            modelDoc.documentName = incoming.documentName;
          }
        });
      },
    },
    model: {
      deep: true,
      handler(newVal) {
        this.$emit('input', newVal);
      },
    },
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
</style>